import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { CustomPanel, PageHeader } from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as XmlImportLogHttp from '../../../../services/api/https/deliveries/xml-import-log.http'
import XmlImportLogTab from '../../Sistema/ConfiguracoesRoboXml/XmlImportLogTab'

function LogsXmlRobot({ history, selectedTp, dispatch }) {
  useEffect(() => {
    if (!selectedTp) {
      dispatch(showMessageBox(null, 'Selecione um Operador Logístico (TP) para acessar esta tela.'))
      history.goBack()
    }
  }, [selectedTp])

  if (!selectedTp) return null

  return (
    <div>
      <PageHeader>Logs XML-Robot</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <XmlImportLogTab
            fetchLogs={(pInicial, pFinal) =>
              XmlImportLogHttp.getXmlImportLogsByTp(selectedTp, pInicial, pFinal)
            }
            downloadLog={logId => XmlImportLogHttp.downloadXmlImportLogByTp(selectedTp, logId)}
            showMessageBox={(msgOk, msgNok) => dispatch(showMessageBox(msgOk, msgNok))}
            showTpFilter={false}
          />
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(LogsXmlRobot))
